import { Button, Grid } from '@mui/material'
import { useScreenSize } from '../../../../../sharedComponents/src/hooks/useScreenSize'

type Props = {
    onNewGame?: () => void
    onRematch?: () => void
    onAnalysis?: () => void
}

export const GameOverNavigation = ({ onNewGame, onRematch, onAnalysis }: Props) => {
    const { isMobile } = useScreenSize()

    return (
        <Grid container gap={{ xs: '8px', md: '16px' }}>
            <Grid display="flex" gap={{ xs: '8px', md: '16px' }} flexGrow={1}>
                {onNewGame && (
                    <Button fullWidth variant="contained" size={isMobile ? 'medium' : 'large'} onClick={onNewGame}>
                        New Game
                    </Button>
                )}
                {onRematch && (
                    <Button fullWidth variant="contained" size={isMobile ? 'medium' : 'large'} onClick={onRematch}>
                        Rematch
                    </Button>
                )}
            </Grid>
            {onAnalysis && (
                <Button variant="contained" fullWidth size={isMobile ? 'medium' : 'large'} onClick={onAnalysis}>
                    Analysis
                </Button>
            )}
        </Grid>
    )
}
